import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatToolDefaultVariants = {
  "status": "complete"
}
const chatToolCompoundVariants = []

const chatToolSlotNames = [
  [
    "group",
    "chatTool__group"
  ],
  [
    "groupTrigger",
    "chatTool__groupTrigger"
  ],
  [
    "groupContent",
    "chatTool__groupContent"
  ],
  [
    "card",
    "chatTool__card"
  ],
  [
    "header",
    "chatTool__header"
  ],
  [
    "name",
    "chatTool__name"
  ],
  [
    "status",
    "chatTool__status"
  ],
  [
    "chip",
    "chatTool__chip"
  ],
  [
    "body",
    "chatTool__body"
  ],
  [
    "section",
    "chatTool__section"
  ],
  [
    "sectionLabel",
    "chatTool__sectionLabel"
  ],
  [
    "code",
    "chatTool__code"
  ]
]
const chatToolSlotFns = /* @__PURE__ */ chatToolSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatToolDefaultVariants, getSlotCompoundVariant(chatToolCompoundVariants, slotName))])

const chatToolFn = memo((props = {}) => {
  return Object.fromEntries(chatToolSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatToolVariantKeys = [
  "status"
]
const getVariantProps = (variants) => ({ ...chatToolDefaultVariants, ...compact(variants) })

export const chatTool = /* @__PURE__ */ Object.assign(chatToolFn, {
  __recipe__: false,
  __name__: 'chatTool',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatToolVariantKeys,
  variantMap: {
  "status": [
    "running",
    "awaiting",
    "complete",
    "error"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatToolVariantKeys)
  },
  getVariantProps
})